import { render } from "./fotito2.vue?vue&type=template&id=2fc1318e&scoped=true"
import script from "./fotito2.vue?vue&type=script&lang=js"
export * from "./fotito2.vue?vue&type=script&lang=js"

import "./fotito2.vue?vue&type=style&index=0&id=2fc1318e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc1318e"]])

export default __exports__